/**
 * Scrolls a table row into view within a scrollable container, accounting for sticky `thead`
 * (same behavior as `DataTable` — see `table.tsx`).
 */
export function scrollTableRowIntoView(row: HTMLTableRowElement, container: HTMLElement | null) {
  if (!container) return;
  const rowRect = row.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const thead = container.querySelector('thead');
  const theadBottom = thead ? thead.getBoundingClientRect().bottom : containerRect.top;
  const stickyOffset = Math.max(0, theadBottom - containerRect.top);
  const topBoundary = containerRect.top + stickyOffset;
  if (rowRect.top < topBoundary) {
    container.scrollTop -= topBoundary - rowRect.top + 1;
  } else if (rowRect.bottom > containerRect.bottom) {
    container.scrollTop += rowRect.bottom - containerRect.bottom + 1;
  }
}
